/**
 * Accept the formats a merchant is likely to paste and normalize to the canonical
 * `<handle>.myshopify.com` the backend expects:
 *   - modern admin URL:  admin.shopify.com/store/<handle>
 *   - classic domain:    <handle>.myshopify.com  (with/without https://, /admin, a query or a
 *                        trailing slash; any case)
 *   - bare store handle: <handle>
 * Returns null when it can't resolve a handle.
 *
 * VRG-724 — shared by both Shopify connect entry points (InstallationHandleModal and
 * ConnectShopifyModal), which used to validate differently. The API normalises the same way
 * (`apps/api/src/features/ecommerce-integrations/shared/shopify-shop-domain.ts`) and stores only the
 * normalised form, so this is the friendly first answer, not the security boundary.
 */
const SHOP_HANDLE = '[a-z0-9](?:[a-z0-9-]*[a-z0-9])?'

export const normalizeShopifyDomain = (raw: string): string | null => {
  let v = (raw || '').trim().toLowerCase()
  if (!v) return null
  v = v.replace(/^https?:\/\//, '')
  const adminUrl = v.match(new RegExp(`^admin\\.shopify\\.com/store/(${SHOP_HANDLE})(?:[/?#]|$)`))
  if (adminUrl) return `${adminUrl[1]}.myshopify.com`
  // Drop any trailing path/query (e.g. <handle>.myshopify.com/admin)
  v = v.split(/[/?#]/)[0]
  if (new RegExp(`^${SHOP_HANDLE}\\.myshopify\\.com$`).test(v)) return v
  if (new RegExp(`^${SHOP_HANDLE}$`).test(v)) return `${v}.myshopify.com`
  return null
}
